export default __webpack_public_path__ + "static/media/playwright.97067b4d.svg";